import classNames from "classnames";
import React from "react";
import Link from "next/link";
import { getHost, getSubjectDetailUrl } from "@/utils/URL";
import styles from "./index.module.scss";

export type SubjectListProps = {
  list: {
    searchWord?: string;
    topicId?: number;
  }[];
} & React.HTMLAttributes<HTMLDivElement>;

const SubjectList = (props: SubjectListProps) => {
  const { list, className, ...restProps } = props;

  return (
    <div className={classNames(styles.container, className)} {...restProps}>
      {list.map((item) => {
        const { searchWord, topicId } = item;
        return (
          <Link
            key={topicId}
            href={getHost() + getSubjectDetailUrl(`${topicId}`)}
            title={searchWord}
            className={classNames(styles.item, "ell")}
          >
            {searchWord}
          </Link>
        );
      })}
    </div>
  );
};

export default SubjectList;
